import { render, staticRenderFns } from "./BugList.vue?vue&type=template&id=807eb59e&"
import script from "./BugList.vue?vue&type=script&lang=ts&"
export * from "./BugList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports